import { cn } from "@tellescope/utils";
import { Label, RichTextEditor } from "@tellescope/ui";
import { TellescopeFormFieldBaseProps } from "../types";
import { FieldDescription } from "../FieldDescription";

export interface RichTextFieldProps extends TellescopeFormFieldBaseProps<"Rich Text"> {
  editable?: boolean;
}

export const RichTextField = ({
  title,
  description,
  htmlDescription,
  value = "",
  onChange,
  className,
  placeholder,
  editable = true,
  error,
  onBlur,
  touched,
  disabled,
  required,
  autoFocus,
}: RichTextFieldProps) => {
  const showError = !!(error && touched);

  return (
    <div className={cn("space-y-2", className)}>
      {!!(title || placeholder) && (
        <Label className="text-sm font-medium" required={required}>
          {title || placeholder}
        </Label>
      )}
      <FieldDescription description={description} htmlDescription={htmlDescription} />
      <RichTextEditor
        content={value}
        onChange={onChange}
        placeholder={placeholder}
        editable={editable && !disabled}
        onBlur={onBlur}
        className={cn(showError && "border-destructive")}
        autoFocus={autoFocus}
        allowImages={false}
      />
      {showError && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
